import * as z from "zod/v4";
import { makeReportDateFilterSchema } from "./base-report-date-filter";
import { ReportFilterType } from "./report-filter-type";

export const ReturnDeliveryDateFilterSchema = makeReportDateFilterSchema(
  ReportFilterType.RETURN_DELIVERY_DATE,
);

export type ReturnDeliveryDateFilter = z.infer<
  typeof ReturnDeliveryDateFilterSchema
>;
